import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../stores/useAuthStore'

/**
 * Garde de route : redirige vers /auth si l'utilisateur n'est pas authentifié.
 * Préserve l'URL demandée pour rediriger après connexion.
 */
export default function ProtectedRoute({ children }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const isInitializing = useAuthStore((s) => s.isInitializing)
  const sessionExpired = useAuthStore((s) => s.sessionExpired)
  const location = useLocation()

  // Pendant la restauration de session, afficher un loader
  if (isInitializing) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-500">
        Chargement...
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" state={{ from: location, sessionExpired }} replace />
  }

  return children
}
